angular.module('app.api').factory('HiringApi', [
  'api',
  function HiringApi(api) {
    const hiringApi = {
      createEmployerEnquiry: payload => {
        return api.post(`landing/new-employer`, payload)
      },
    }
    return hiringApi
  },
])



// WEBPACK FOOTER //
// ./scripts/hiring/hiring.api.js